import CategoryList from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-category-list.js?v=164540137399097351091770343638";
import TabContents from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-tab-contents.js?v=29982373133339823951729269517";
import ProductItem from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-product-item.js?v=13457192605502936901792048631";
import StaffRoomSlider from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-staffroom-slider.js?v=110268387286611046231719298709";
import MVSlider from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-mv-slider.js?v=3202474670019908041739859101";
// import nowSlider from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-now-slider.js?v=173961861482563304781745543294";
import PulldownSort from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-pulldown-sort.js?v=87029894567731322181727943184";
import PulldownPrice from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-pulldown-price.js?v=8134758178892097041730176761";
import SearchArea from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-search-area.js?v=115837710259590094391776656812";
import CollectionsArea from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-collections-area.js?v=151701648214047333061744272599";
import StockButton from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-stock-button.js?v=137245472737238312501730284290";
import ShareButton from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-share-button.js?v=117407282090095478241739339431";
import ProductImage from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-product-image.js?v=60975982874135035101728011768";
import ProductStock from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-product-stock.js?v=6137265999666832131770617008";
import OrderModal from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-order-modal.js?v=171168908749317961401719298711";
import CounterBox from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-counter-box.js?v=5659013164495897321790205349";
import ProductDetail from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-product-detail.js?v=132754687563020621311765252870";
import CustomRadioButton from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-radio-button.js?v=100413944423923604401758686457";
import ToggleButton from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-toggle-button.js?v=121634580344802830571721633600";
import ToggleContent from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-toggle-content.js?v=128381948610520561271725234643";
import CustomModal from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-modal.js?v=22320373585593412861770337493";
import UnicoHeader from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-header.js?v=89074469920369720281770343639";
import EstimateOrder from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-estimate-order.js?v=62419179006320115501728632834";
import RemoveButton from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-remove-button.js?v=168102788361629291261776736828";
import DrawerMenu from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-drawer-menu.js?v=119077723676765678601725234642";
import CollectionNav from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-collection-nav.js?v=43037028256486482661783396146";
import CategorySubnav from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-category-subnav.js?v=58527713655351506401783396145";
import PopupBanner from "//www.unico-fan.co.jp/cdn/shop/t/16/assets/script-popup-banner.js?v=109972777416986678221735293802";

// コレクションナビゲーション
customElements.define('unico-collection-nav', CollectionNav);
customElements.define('unico-category-subnav', CategorySubnav);

// 共通パーツ
customElements.define('unico-header', UnicoHeader);
customElements.define('unico-estimate-order', EstimateOrder);

// セクションパーツ
customElements.define('unico-category-list', CategoryList);
customElements.define('unico-tab-contents', TabContents);
customElements.define('unico-product-item', ProductItem);
customElements.define('unico-mv-slider', MVSlider);
// customElements.define('unico-now-slider', nowSlider);
customElements.define('unico-search-area', SearchArea);
customElements.define('unico-collections-area', CollectionsArea);

// プルダウンパーツ
customElements.define('unico-pulldown-sort', PulldownSort);
customElements.define('unico-pulldown-price', PulldownPrice);

// ボタンパーツ
customElements.define('unico-stock-button', StockButton);
customElements.define('unico-share-button', ShareButton);
customElements.define('unico-radio-button', CustomRadioButton);
customElements.define('unico-toggle-button', ToggleButton);

// 詳細画面パーツ
customElements.define('unico-product-detail', ProductDetail);
customElements.define('unico-product-image', ProductImage);
customElements.define('unico-product-stock', ProductStock);
customElements.define('unico-order-modal', OrderModal);
customElements.define('unico-counter-box', CounterBox);
customElements.define('unico-remove-button', RemoveButton);

// モーダルパーツ
customElements.define('unico-modal', CustomModal);

// ドロワーパーツ
customElements.define('unico-drawer-menu', DrawerMenu);

// 開閉式パーツ
customElements.define('unico-toggle-content', ToggleContent);

// ポップアップバナー
customElements.define('unico-popup-banner', PopupBanner);
